module.exports = __webpack_public_path__ + "static/img/nav10.97abf3fa.svg";